import { faAngleDown, faAngleUp } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { withLiteObserverAndTheme } from "../../../core/et3-enhanced-render";
import { TMenuDropDownItemProps } from "../../../Types";
import AnimatedDropdown from "./AnimatedDropdown";
import ET3Div from "../../../core/et3-div";
import Et3Text from "../../../core/et3-text";
import Et3Margin from "../../../core/et3-ui/ET3Margin";
import ET3Circle from "../../../core/et3-circle";
import Et3CustomizedButton from "../../../core/et3-button/Et3CustomizedButton";
import getDashBoardStore from "../../../stores/dashboard-store";
import React from "react";

const MenuDropdownItem = withLiteObserverAndTheme<TMenuDropDownItemProps>(
  (props) => {
    const {
      icon,
      title,
      options,
      isMenuOpenObservable,
      theme,
      onPress,
      visible
    } = props;
    const { colors, unitX, unitY } = theme;
    const isMenuOpen = isMenuOpenObservable.get();
    const isAlert = getDashBoardStore().getIsAlert.get();
    return visible ? (
      <React.Fragment>
        <Et3CustomizedButton
          isEnabled={true}
          withShadow={false}
          width={280}
          height={60}
          fDirection="row"
          alignItems="center"
          justifyContent="flex-start"
          color={colors.all.transparent}
          style={{}}
          onClick={() => {
            onPress();
            isMenuOpenObservable.set(!isMenuOpen);
          }}
        >
          <ET3Div
            isScrollable={false}
            isExtendable={false}
            withShadow={false}
            width={260}
            height={50}
            fDirection="row"
            alignItems="center"
            justifyContent="space-between"
            color={colors.all.transparent}
            style={{}}
            onClick={() => {}}
          >
            <ET3Div
              isScrollable={false}
              isExtendable={false}
              withShadow={false}
              width={190}
              height={50}
              fDirection="row"
              alignItems="center"
              justifyContent="flex-start"
              color={colors.all.transparent}
              style={{}}
              onClick={() => {}}
            >
              <FontAwesomeIcon
                icon={icon}
                color={colors.all.white}
                style={{
                  width: 18 * unitX,
                  height: 18 * unitY
                }}
              />
              <Et3Margin top={0} bottom={0} left={7} right={7} />
              <Et3Text
                fontFamily={"BOLD"}
                fontSize={18}
                text={title}
                isSpan={false}
                color={colors.all.white}
                style={{}}
              />
            </ET3Div>
            <ET3Circle
              size={21}
              withShadow={false}
              color={isAlert ? colors.all.white : colors.all.bondiBlue}
              style={{
                justifyContent: "center",
                alignItems: "center"
              }}
              onClick={() => {}}
            >
              <FontAwesomeIcon
                icon={isMenuOpen ? faAngleUp : faAngleDown}
                color={isAlert ? colors.all.red : colors.all.white}
                style={{
                  width: 17 * unitX,
                  height: 17 * unitY
                }}
              />
            </ET3Circle>
          </ET3Div>
        </Et3CustomizedButton>
        <AnimatedDropdown options={options} isMenuOpen={isMenuOpen} />
      </React.Fragment>
    ) : null;
  }
);
export default MenuDropdownItem;
